import UploadNewsForm from "../../UploadNewsForm";
import { createHealth } from "../../../api";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CreateNewHealth() {
  const navigate = useNavigate();
  const customSubmitFunction = async (title, description, image) => {
    try {
      const result = await createHealth(title, description, image);
      if (result) {
        navigate("/health/all");
      }
    } catch (error) {}
  };
  return (
    <>
      <Container>
        <UploadNewsForm
          customsubmit={customSubmitFunction}
          breadCrumbLink={"Health"}
          breadCrumbText={"Create New"}
          goBackLink={"/health/all"}
        />
      </Container>
    </>
  );
}
